package com.github.jangalinski.tabweb._foundation.size

/**
 * DEFAULT points to MEDIUM size, which is the default size for most components.
 */
data object DEFAULT : SmallToLargeX
